import { ClientOnly } from "vike-react/ClientOnly";
import { Button } from "#components/Button.tsx";
import Modal from "#components/Modal.tsx";

export default function JoinModal({
	open,
	onClose,
}: {
	readonly open: boolean;
	readonly onClose: () => void;
}) {
	return (
		<ClientOnly>
			<Modal open={open} onClose={onClose}>
				<div className="w-full aspect-video">
					<iframe
						title="YouTube video player"
						src="https://www.youtube.com/embed/WDZQC856Zl4?rel=0&modestbranding=1&controls=1"
						className="w-full h-full"
						referrerPolicy="strict-origin-when-cross-origin"
						frameBorder={0}
						allow="autoplay; encrypted-media; picture-in-picture"
						allowFullScreen
					/>
				</div>

				<h1 className="text-title font-heading text-amber-500 pt-6 pb-3 text-center font-semibold">
					A Few Good Agents Requested
				</h1>
				<div className="space-y-3 text-center">
					<p>
						Due to the unexpected unavailability of Agent Isaiah Jones, standard
						rookie training has been temporarily suspended. However, select
						candidates are being quietly considered to assist with sensitive
						research into Agent Jones's disappearance. While The String Society
						maintains full operational integrity, fresh perspectives may
						prove... useful.
					</p>
					<p>
						If you believe you're up to the task, submit your application below.
					</p>
				</div>
				<Button className="w-full mt-5" href="/auth/register">
					Apply Now
				</Button>
			</Modal>
		</ClientOnly>
	);
}
